import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, AppStore } from '../state/store';
import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../state/slices';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();
export const useAppSelector = useSelector.withTypes<RootState>();
export const useAppStore = useStore.withTypes<AppStore>();
export const createAppSelector = createSelector.withTypes<RootState>();
